import React from "react";
import ArticleCarouselStyles from "../../styles/ArticleCarouselStyles";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import Carousel from "react-img-carousel";
require("react-img-carousel/lib/carousel.css");

const ArticleCarousel = () => {
  return (
    <ArticleCarouselStyles>
      <Carousel
        style={{
          slide: {
            opacity: 1,
          },
          selectedSlide: {
            opacity: 1,
          },
        }}
        slideWidth="250px"
        height="300px"
        arrows={true}
        slideHeight="300px"
        autoplay={false}
        transition="slide"
        transitionDuration="700"
        lazyLoad={true}
        cellPadding={10}
        slideAlignment="left"
        className="article-carousel"
      >
        <Link
          to="/content/best-of/amsterdam/7-amsterdam-terraces-you-wont-want-to-miss-this-spring"
          style={{
            display: "grid",
          }}
        >
          <StaticImage
            style={{
              gridArea: "1/1",
              maxHeight: 300,
              minHeight: 300,
            }}
            // This is a presentational image, so the alt should be an empty string
            layout="constrained"
            alt="Best amsterdam terrace for summer outdoor dining- Domenica"
            src={
              "https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_714/v1622542784/articles/amsterdam/Domenica-_tables_1_mmss5d.jpg"
            }
            loading="eager"
            placeholder="blurred"
            objectPosition="left bottom"
            className="card"
          />
          <div
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: "1/1",
              position: "relative",
            }}
            className="card-text"
          >
            <p>
              <span>Best Terraces for Sunny Days in Amsterdam</span>
            </p>
          </div>
        </Link>
        <Link
          to="/content/best-of/amsterdam/amsterdam-by-district-our-spring-favorites-in-the-citys-noord"
          style={{
            display: "grid",
          }}
        >
          <StaticImage
            style={{
              gridArea: "1/1",
              maxHeight: 300,
              minHeight: 300,
            }}
            // This is a presentational image, so the alt should be an empty string
            layout="constrained"
            alt="Best Amsterdam restaurants in Noord- Public Space"
            src={
              "https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_966/v1618317909/articles/amsterdam/public-space-sandwich_c03gwe.jpg"
            }
            loading="eager"
            placeholder="blurred"
            objectPosition="center"
            className="card"
          />
          <div
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: "1/1",
              position: "relative",
            }}
            className="card-text"
          >
            <p>
              <span>Local Favorites in Amsterdam Noord</span>
            </p>
          </div>
        </Link>
        <Link
          to="/content/best-of/amsterdam/7-top-amsterdam-eateries-owned-and-run-by-women"
          style={{
            display: "grid",
          }}
        >
          <StaticImage
            style={{
              gridArea: "1/1",
              maxHeight: 300,
              minHeight: 300,
            }}
            // This is a presentational image, so the alt should be an empty string
            layout="constrained"
            alt="Best Amsterdam restaurants owned and run by women- Back to Black coffee house"
            src={
              "https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_965/v1615304433/articles/amsterdam/BacktoBlack-76_3_fjx01x.jpg"
            }
            loading="eager"
            placeholder="blurred"
            objectPosition="center"
            className="card"
          />
          <div
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: "1/1",
              position: "relative",
            }}
            className="card-text"
          >
            <p>
              <span>Top Amsterdam Eateries Run by Women</span>
            </p>
          </div>
        </Link>
        <Link
          to="/content/best-of/amsterdam/6-sustainable-eateries-for-a-revitalizing-new-year"
          style={{
            display: "grid",
          }}
        >
          <StaticImage
            style={{
              gridArea: "1/1",
              maxHeight: 300,
              minHeight: 300,
            }}
            // This is a presentational image, so the alt should be an empty string
            layout="constrained"
            alt="Most sustainable Amsterdam restaurants for 2021- colorful plant based meal by Vegabond"
            src={
              "https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_965/v1609213919/articles/amsterdam/Vegabond_header_s20hn8.jpg"
            }
            loading="eager"
            placeholder="blurred"
            objectPosition="center"
            className="card"
          />
          <div
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: "1/1",
              position: "relative",
            }}
            className="card-text"
          >
            <p>
              <span>Sustainable Restaurants for a Healthy 2021</span>
            </p>
          </div>
        </Link>
        <Link
          to="/content/interviews/amsterdam/behind-the-values-with-lot61"
          style={{
            display: "grid",
          }}
        >
          <StaticImage
            style={{
              gridArea: "1/1",
              maxHeight: 300,
              minHeight: 300,
            }}
            // This is a presentational image, so the alt should be an empty string
            layout="constrained"
            alt="Espresso machine from Amsterdam coffee roaster and supplier LOT61"
            src={
              "https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_966/v1621854680/articles/amsterdam/coffee-machine_ekcrq5.jpg"
            }
            loading="eager"
            placeholder="blurred"
            objectPosition="center"
            className="card"
          />
          <div
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: "1/1",
              position: "relative",
            }}
            className="card-text"
          >
            <p>
              <span>Exclusive Interview with Coffee Roastery LOT61</span>
            </p>
          </div>
        </Link>
      </Carousel>
    </ArticleCarouselStyles>
  );
};

export default ArticleCarousel;
